import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Philosophy from "@/pages/Philosophy";
import Legacy from "@/pages/Legacy";
import Blueprint from "@/pages/Blueprint";
import PlayerDevelopment from "@/pages/PlayerDevelopment";
import Resume from "@/pages/Resume";
import Contact from "@/pages/Contact";
import Journal from "@/pages/Journal";
import Media from "@/pages/Media";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/philosophy" element={<Philosophy />} />
              <Route path="/legacy" element={<Legacy />} />
              <Route path="/blueprint" element={<Blueprint />} />
              <Route path="/player-development" element={<PlayerDevelopment />} />
              <Route path="/journal" element={<Journal />} />
              <Route path="/media" element={<Media />} />
              <Route path="/resume" element={<Resume />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </SmoothScroll>
        <Toaster position="top-center" />
      </BrowserRouter>
    </div>
  );
}

export default App;
